export default __webpack_public_path__ + "static/media/044-drawing.d1c9abe3.svg";